import ErrorNoti from 'components/common/ErrorNoti';
import Loading from 'components/common/Loading';
import Modal from 'components/common/Modal';
import useInviteModal from 'hooks/service/useInviteModal';
import { CloseBtn } from 'lib/styles/icons';
import { newInputStyle } from 'lib/styles/index';
import palette from 'lib/styles/palette';
import { useState } from 'react';
import styled from 'styled-components';

const StoreBoxRow = ({ store, onClick, setFocused }) => {
  return (
    <StoreBoxRowBlock>
      <div
        onClick={() => {
          onClick(store.store, store.storeId);
          setFocused(false);
        }}
      >
        {store.store}
      </div>
    </StoreBoxRowBlock>
  );
};

const StoreBoxRowBlock = styled.div`
  cursor: pointer;
  div {
    padding: 5px 0;
  }
  &:hover {
    color: ${palette.theme[3]};
  }
`;

const InviteModal = ({ title, closeModal }) => {
  const [focused, setFocused] = useState(false);
  const [serverError, setServerError] = useState('');
  const {
    email,
    name,
    store,
    onChange,
    onClick,
    onSubmit,
    filteredStoreList,
    inviteUser,
    errors,
  } = useInviteModal(title, closeModal, setServerError);

  return (
    <Modal closeModal={closeModal}>
      <InviteModalBlock>
        {inviteUser.isLoading ? (
          <Loading padding />
        ) : inviteUser.error?.response.status === 500 ? (
          <ErrorNoti padding errorMsg={inviteUser.error.response.data.msg} />
        ) : (
          <>
            <div className="title">{`${title} 초대`}</div>
            <div className="close-btn">
              <CloseBtn onClick={closeModal} />
            </div>
            <div className="msg">
              초대할 구성원의 정보를 입력하면 이메일로 초대 링크가 전송됩니다
            </div>
            <form onSubmit={onSubmit}>
              <div className="invite-modal-row">
                <div className="index">소속</div>
                <div>
                  <input
                    type="text"
                    name="store"
                    value={store}
                    autoComplete="off"
                    autoFocus
                    onChange={onChange}
                    onFocus={() => setFocused(true)}
                  />
                </div>
                {focused && (
                  <div className="store-box">
                    {filteredStoreList?.map(store => (
                      <StoreBoxRow
                        key={store.storeId}
                        store={store}
                        onClick={onClick}
                        setFocused={setFocused}
                      />
                    ))}
                  </div>
                )}
              </div>
              {errors.store && (
                <div className="validation-msg">{errors.store}</div>
              )}
              <div className="invite-modal-row">
                <div className="index">직급</div>
                <input type="text" value={title} disabled />
              </div>
              <div className="invite-modal-row">
                <div className="index">이름</div>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={onChange}
                />
              </div>
              {errors.name && (
                <div className="validation-msg">{errors.name}</div>
              )}
              <div className="invite-modal-row">
                <div className="index">이메일</div>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={onChange}
                />
              </div>
              {errors.email && (
                <div className="validation-msg">{errors.email}</div>
              )}
              {serverError && (
                <div
                  style={{
                    marginTop: 20,
                    textAlign: 'center',
                    color: 'red',
                    fontSize: 14,
                  }}
                >
                  {serverError}
                </div>
              )}
              <div className="invite-modal-btn-wrapper">
                <button className="btn" disabled={focused}>
                  링크 전송
                </button>
              </div>
            </form>
          </>
        )}
      </InviteModalBlock>
    </Modal>
  );
};

export default InviteModal;

const InviteModalBlock = styled.div`
  width: 480px;
  padding: 0 1rem;
  position: relative;

  .close-btn {
    position: absolute;
    top: 5px;
    right: 20px;
    font-size: 18px;
    &:hover {
      color: ${palette.gray[6]};
    }
  }

  .title {
    margin-top: 1rem;
  }

  .msg {
    margin: 1rem 0;
    font-size: 14px;
    text-align: center;
  }

  .invite-modal-row {
    margin: 0 2rem;
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    position: relative;
  }

  .validation-msg {
    font-size: 12px;
    margin-left: 145px;
    color: red;
  }

  .invite-modal-btn-wrapper {
    display: flex;
    justify-content: center;
    margin: 1rem;
  }

  .store-box {
    width: 280px;
    height: 130px;
    padding: 0.5rem 1rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background: #fff;
    font-size: 12px;
    position: absolute;
    z-index: 100;
    top: 28px;
    left: 104px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
      background: ${palette.theme[0]};
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${palette.theme[3]};
      border-radius: 10px;
    }
  }

  input {
    ${newInputStyle}
    width: 280px;
    padding: 0.3rem 0.5rem;
    &:disabled {
      background: ${palette.gray[3]};
    }
  }

  button:disabled {
    background: ${palette.gray[3]};
    &:hover {
      background: ${palette.gray[3]};
    }
  }
`;
